import React from 'react';
import { Clock, Users, TrendingUp, Brain, ArrowRight } from 'lucide-react';
import { coachingPrograms } from '../data/mockData';
import '../styles/programs.css';

const ProgramsSection = () => {
  const getIcon = (iconName) => {
    const icons = {
      bat: <TrendingUp size={32} />,
      gloves: <Target size={32} />,
      users: <Users size={32} />,
      brain: <Brain size={32} />
    };
    return icons[iconName] || <TrendingUp size={32} />;
  };

  const scrollToContact = () => {
    const element = document.querySelector('#contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="programs" className="programs-section">
      <div className="container">
        <div className="programs-header">
          <div className="section-label">
            <span>Training Programs</span>
          </div>
          <h2 className="section-title">
            Choose Your Path to <span className="text-highlight">Excellence</span>
          </h2>
          <p className="programs-subtitle">
            Comprehensive coaching programs designed for players at every level
          </p>
        </div>

        <div className="programs-grid">
          {coachingPrograms.map((program) => (
            <div key={program.id} className="program-card">
              <div className="program-header">
                <div className="program-icon">{getIcon(program.icon)}</div>
                <div className="program-level">{program.level}</div>
              </div>
              
              <h3 className="program-title">{program.title}</h3>
              <p className="program-description">{program.description}</p>
              
              <div className="program-meta">
                <div className="meta-item">
                  <Clock size={16} />
                  <span>{program.duration}</span>
                </div>
                <div className="meta-item">
                  <Users size={16} />
                  <span>{program.sessions}</span>
                </div>
              </div>
              
              <div className="program-features">
                {program.features.map((feature, index) => (
                  <div key={index} className="feature-item">
                    <div className="feature-check">✓</div>
                    <span>{feature}</span>
                  </div>
                ))}
              </div>
              
              <button className="program-cta" onClick={scrollToContact}>
                Enroll Now
                <ArrowRight size={18} />
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const Target = ({ size }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"></circle>
    <circle cx="12" cy="12" r="6"></circle>
    <circle cx="12" cy="12" r="2"></circle>
  </svg>
);

export default ProgramsSection;
